import { useQuery, UseQueryResult } from 'react-query';
import { StaffRetrieve } from 'types';
import { client } from 'utils/api-client';

function useSelfStaff(): UseQueryResult<{ data: StaffRetrieve }> {
  return useQuery(['staff', 'self'], () => client.get(`staff/self`));
}

export default useSelfStaff;
